<template>
    <div class="container">
        <!-- <Breadcrumb class="bread_block" />  -->
        <CommonBreadcrumb class="bread_block"/>
        <div class="row">
            <div class="col-md-12 mb-4">
                <h1 class="font-active">Finding Your Ring Size</h1>
            </div>
            
            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_1.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_1.jpg" alt="How to Find Ring Size - Step one">
                </picture>
                <h3 class="mt-4 mb-3">STEP ONE</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">Take a thread string or a piece of paper and wrap it around the base of the finger you want to measure (Like shown in the above image).</p>
                <p class="mb-0 text-center" v-else>Wrap a string, piece of paper, or fabric around the base of the finger on which you plan to wear your ring.</p>
            </div>
            
            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_2.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_2.jpg" alt="How to Find Ring Size - Step two">
                </picture>
                <h3 class="mt-4 mb-3">STEP TWO</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">Mark where the string or paper first overlaps using a pen; ensure it is not too tight or too loose on your finger (like shown in the above image).</p>
                <p class="mb-0 text-center" v-else>Make sure the string, fabric, or paper is snugly wrapped, but not tight; and make a marking at the point where it overlaps.</p>
            </div>

            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_3.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_3.jpg" alt="How to Find Ring Size - Step three">
                </picture>
                <h3 class="mt-4 mb-3">STEP THREE</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">To determine your ring size, measure the length of the string or paper in millimeters with a ruler. Refer to the conversion chart below for the approximate length of the ring's circumference.</p>
                <p class="mb-0 text-center" v-else>To determine your ring size, measure the length of the same in millimeter with a ruler. Refer to the conversion chart provided below with your calculated length which is also the circumference of your ring.</p>
            </div>    
        </div>

        <div class="row mt-4 pt-4" v-if="$country.is_india">
            <div class="col-md-12 overflow_box">
                <div class="block_supplier_size">
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">India Size</div>
                            <span>8</span><span>9</span><span>10</span><span>11</span>
                            <span>12</span><span>13</span><span>14</span><span>15</span>
                            <span>16</span><span>17</span><span>18</span><span>19</span>
                            <span>20</span><span>21</span><span>22</span><span>23</span>
                            <span>24</span><span>25</span><span>26</span><span>27</span>
                        </div>
                    </div>
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">Circumference (mm)</div>
                            <span>48.1</span><span>49.0</span><span>50.0</span><span>50.9</span>
                            <span>51.8</span><span>52.8</span><span>54.0</span><span>55.0</span>
                            <span>55.9</span><span>56.9</span><span>57.8</span><span>59.1</span>
                            <span>60.0</span><span>60.9</span><span>61.9</span><span>62.8</span>
                            <span>63.8</span><span>64.7</span><span>66.0</span><span>66.9</span>
                        </div>
                    </div>
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">Circumference (inches)</div>
                            <span>1.89</span><span>1.93</span><span>1.97</span><span>2.0</span>
                            <span>2.04</span><span>2.08</span><span>2.13</span><span>2.16</span>
                            <span>2.2</span><span>2.24</span><span>2.28</span><span>2.33</span>
                            <span>2.36</span><span>2.4</span><span>2.44</span><span>2.47</span>
                            <span>2.51</span><span>2.55</span><span>2.6</span><span>2.63</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row mt-4 pt-4" v-else>
            <div class="col-md-12 overflow_box">
                <div class="block_supplier_size">
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">Length (mm)</div>
                            <span>47</span><span>48</span><span>49</span><span>50</span>
                            <span>51</span><span>52</span><span>53</span><span>54</span>
                            <span>55</span><span>56</span><span>57</span><span>58</span>
                            <span>59</span><span>60</span><span>61</span><span>62</span>
                            <span>63</span><span>64</span><span>65</span><span>66</span>
                            <span>68</span><span>69</span>
                        </div>
                    </div>
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">US Size</div>
                            <span>3.75</span><span>4.25</span><span>4.75</span><span>5.25</span>
                            <span>5.5</span><span>5.75</span><span>6.25</span><span>6.75</span>
                            <span>7.25</span><span>7.5</span><span>8</span><span>8.25</span>
                            <span>8.5</span><span>9</span><span>9.5</span><span>9.75</span>
                            <span>10</span><span>10.5</span><span>11</span><span>11</span>
                            <span>12</span><span>12.5</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="row mt-5 pt-5">
            <div class="col-md-12 mb-4">
                <h2 class="font-active">Determining Your Ring Size Using An Existing Ring</h2>
            </div>
            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_4.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_4.jpg" alt="Ring Size - Step one">
                </picture>
                <h3 class="mt-4 mb-3">STEP ONE</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">Choose a ring with a comfortable fit that is not too tight or loose on your finger.</p>
                <p class="mb-0 text-center" v-else>Choose a ring with a snug fit which is not too tight or loose on your finger.</p>
            </div>
            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_5.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_5.jpg" alt="Ring Size - Step two">
                </picture>
                <h3 class="mt-4 mb-3">STEP TWO</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">Using a ruler, measure the diameter of the ring from one inside edge to the other in millimeters.</p>
                <p class="mb-0 text-center" v-else>Using a ruler, measure the diameter of the ring from one inside edge to the other inside edge in millimeters.</p>
            </div>
            <div class="col-md-4 text-center mb-4">
                <picture>
                    <source width="426" height="279" type="image/webp" srcset="~/assets/size_guide/step_6.webp">
                    <img class="radious_eight" width="426" height="279" src="~/assets/size_guide/step_6.jpg" alt="Ring Size - Step three">
                </picture>
                <h3 class="mt-4 mb-3">STEP THREE</h3>
                <p class="mb-0 text-center" v-if="$country.is_india">Look to the measurement conversion table provided below to determine your ring size with your calculated diameter.</p>
                <p class="mb-0 text-center" v-else>To determine your ring size, refer to the measurement conversion chart provided below with your calculated diameter.</p>
            </div>
        </div>
        
        <div class="row my-4 py-4" v-if="$country.is_india">
            <div class="col-md-12 overflow_box">
                <div class="block_supplier_size">
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">India Size</div>
                            <span>8</span><span>9</span><span>10</span><span>11</span>
                            <span>12</span><span>13</span><span>14</span><span>15</span>
                            <span>16</span><span>17</span><span>18</span><span>19</span>
                            <span>20</span><span>21</span><span>22</span><span>23</span>
                            <span>24</span><span>25</span><span>26</span><span>27</span>
                        </div>
                    </div>
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">Diameter (mm)</div>
                            <span>15.3</span><span>15.6</span><span>15.9</span><span>16.2</span>
                            <span>16.5</span><span>16.8</span><span>17.2</span><span>17.5</span>
                            <span>17.8</span><span>18.1</span><span>18.4</span><span>18.8</span>
                            <span>19.1</span><span>19.4</span><span>19.7</span><span>20.0</span>
                            <span>20.3</span><span>20.6</span><span>21.0</span><span>21.3</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-4 py-4" v-else>
            <div class="col-md-12 overflow_box">
                <div class="block_supplier_size">
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">US Size</div>
                            <span>3</span><span>3½</span><span>4</span><span>4½</span>
                            <span>5</span><span>5½</span><span>6</span><span>6½</span>
                            <span>7</span><span>7½</span><span>8</span><span>8½</span>
                            <span>9</span><span>9½</span><span>10</span><span>10½</span>
                            <span>11</span><span>11½</span><span>12</span><span>12½</span>
                            <span>13</span><span>13½</span>
                        </div>
                    </div>
                    <div class="supplier_flex">
                        <div class="supplier_box_right">
                            <div class="size_title">Diameter (mm)</div>
                            <span>14.0</span><span>14.4</span><span>14.8</span><span>15.2</span>
                            <span>15.6</span><span>16.0</span><span>16.5</span><span>16.9</span>
                            <span>17.3</span><span>17.7</span><span>18.2</span><span>18.6</span>
                            <span>19.0</span><span>19.4</span><span>19.8</span><span>20.2</span>
                            <span>20.6</span><span>21.0</span><span>21.4</span><span>21.8</span>
                            <span>22.2</span><span>22.6</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row pt-5" v-if="$country.is_india">
            <div class="col-md-12 mb-2">
                <h2 class="text-center font-active">Useful Tips</h2>
                <p class="text-center mt-3">
                    Remember that getting the right size is the first step towards a comfortable and secure fit. There are a few important factors to consider before buying the ring, whether it is an <router-link :to="localePath('/engagement-rings')">engagement ring</router-link>, a wedding band, or a gift for a special occasion. Here are a few additional tips to remember before you make your purchase.
                </p>
            </div>
            <div class="col-md-12 mb-4">
                <h4 class="mb-2 text-left">Average Ring Sizes in India</h4>
                <p class="mb-0 text-left">The average ring size for women in India is between 9 and 14, while for men, it commonly ranges from 17 to 22. Choosing a ring between these ranges is advised if no information is available.</p>
            </div>
            <div class="col-md-12 mb-4">
                <h4 class="mb-2 text-left">Optimal Temperature</h4>
                <p class="mb-0 text-left">Fingers tend to react to temperature and can change size depending on the weather. The cold temperature is believed to shrink the fingers in winter, while the exact opposite happens during summer or when the weather is warm and humid. So, choose a ring that is neither too tight nor too loose.</p>
            </div>
            <div class="col-md-12 mb-4">
                <h4 class="mb-2 text-left">Width of the Bands</h4>
                <p class="mb-0 text-left">Different ring widths can impact the size of the ring. Thicker ring bands exceeding 6mm will fit tighter. When purchasing a ring, we advise always going for half a size for the ring to fit comfortably.</p>
            </div>
        </div>
        
        <FaqDynamicFaq />
    </div>
</template>


<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp() 
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );  
</script>

<style scoped>
h1, h2{
    font-size: 30px;
    text-align: center;
}
h3 {
    font-size: 14px;
    text-align: center;
    font-weight: 700;
}

p {
    font-size: 16px;
    color: #6a6161;
}
p a {
    text-decoration: underline;
}
.supplier_box_right {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
}

.size_title {
    min-width: 200px;
    font-weight: 600;
    padding: 9px;
}

.supplier_box_right span {
    width: 70px;
    font-weight: 500;
    border-left: 1px solid #ccc;
    padding: 10px;
    font-size: 14px;
}
.supplier_flex:nth-child(1) .supplier_box_right {
    border-bottom: 0;
}
.block_supplier_size {
    margin-top: 4%;
}
.supplier_flex {
    width: 1350px;
}
.block_supplier_size {
    overflow-x: auto;
}
h4 {
    font-size: 20px;
   
}
.india_size_block {
    display: flex;
}

.india_size_box {
    width: 25%;
}

.india_size_title {
    display: block;
    width: 100%;
    border: 0;
    padding: 7px 20px;
    background: #668b84;
    color: #fff;
    text-transform: capitalize;
    font-weight: 600;
}

.india_size_box span {
    display: block;
    padding: 7px 20px;
    border-bottom: 1px solid #efeeee;
    min-height: 40px;
    border-right: 1px solid #efeeee;
    font-size: 14px;
}

.india_size_box:nth-child(1) span {
    border-left: 1px solid #efeeee;
}
.india_size_box span:nth-child(odd) {
        background: #f9f9f9;
    }
@media(max-width:1300px){
   
}
@media (max-width: 992px){
    h1, h2{
        font-size: 32px;
    }
    h4 {
        font-size: 18px;
    }
}
@media(max-width:767px){
    .overflow_box {
        overflow-x: auto;
    }
    h4 {
        font-size: 16px;
        font-weight: 600;
    }
    h1, h2{
        font-size: 32px;
    }
    .supplier_flex {
        width: 50%;
        width: 100%;
        display: block;
    }
    .block_supplier_size {
        width: 100%;
        overflow-x: unset;
        display: flex;
        margin-top: 8%;
    }
    .size_title {
        display: flex;
        align-items: center;
        width: 100%;
        border: 0;
        padding: 7px 20px;
        background: #668b84;
        color: #fff;
        min-height: 63px;
    }
    .supplier_box_right span{
        width: 100%;
        display: block;
        border-bottom: 1px solid #efeeee;
        border-left: 0;
        padding: 7px 20px;
        font-size: 14px;
    }
    .supplier_box_right span:nth-child(odd) {
        background: #f9f9f9;
    }
    .supplier_box_right {
        display: block;
        border: 0;
    }
    .supplier_flex:nth-child(1) .supplier_box_right{
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
    }
    .supplier_flex:nth-child(2) .supplier_box_right{
        border-right: 1px solid #ccc;
    }
    .india_size_title {
        font-size: 14px;
        text-align: center;
    }
    .india_size_box:nth-child(1) {
        width: 43%;
    }
    .india_size_box {
        width: 19%;
    }
    .india_size_box span {
        font-size: 14px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>